import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { COLORS } from '~/src/styles/tokens/colors';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

export const CompanySuggestion = styled.div`
    display: block;
    width: 100%;
`;

export const NameLine = styled.div`
    justify-content: space-between;
`;

export const Name = styled.div`
    ${FONTS.sans.medium.size17};
`;

export const MainLine = styled.div`
    ${FONTS.sans.regular.size14};
    padding-top: ${rem(6)};
`;

export const Label = styled.div`
    padding-right: ${rem(4)};
    color: ${COLORS.textSecondary};
    text-transform: uppercase;
    ${FONTS.compact.regular.size12};
    align-items: center;
    flex-wrap: nowrap;
`;

export const CompanyHeadName = styled.div`
    padding-right: ${rem(8)};
    ${FONTS.sans.regular.size14};
`;

export const Address = styled.div`
    color: ${COLORS.textSecondary};
    ${FONTS.compact.regular.size14};
`;

export const CodesLine = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-top: ${rem(2)};
`;

export const CodeWrap = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    ${FONTS.compact.regular.size14};
    &:not(:last-child) {
        padding-right: ${rem(16)};
    }
`;

export const Status = styled.div<{ backgroundColor: string; }>`
    height: ${rem(20)};
    align-items: center;
    ${FONTS.sans.medium.size12};
    padding: 0 ${rem(12)};
    background-color: ${(p) => p.backgroundColor};
    border-radius: ${BORDER_RADIUS.bigger12};
`;
